module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_STRESS-hauptseite-hintergrund.1e675105.jpg";